module.exports = __webpack_public_path__ + "static/media/hpf.d18d421c.png";